export const PAYMENT_METHOD = {
    CARD: 'card',
    CASH_REGISTER: 'cash_register',
    CASH_HAND: 'cash_hand',
    ONLINE: 'online',
};
/** Methods collected face to face - these are the ones sent to EET. */
export const IN_PERSON_METHODS = [
    PAYMENT_METHOD.CARD,
    PAYMENT_METHOD.CASH_REGISTER,
    PAYMENT_METHOD.CASH_HAND,
];
/** Methods an instructor (role < 50) may pick. */
export const INSTRUCTOR_METHODS = [
    PAYMENT_METHOD.CASH_HAND,
    PAYMENT_METHOD.CARD,
];
export const PAYMENT_METHODS = [
    {
        id: PAYMENT_METHOD.CASH_HAND,
        title: 'Hotově do ruky',
        icon: 'mdi-cash',
    },
    {
        id: PAYMENT_METHOD.CASH_REGISTER,
        title: 'Hotově do pokladny',
        icon: 'mdi-cash-register',
    },
    {
        id: PAYMENT_METHOD.CARD,
        title: 'Kartou',
        icon: 'mdi-credit-card',
    },
    {
        id: PAYMENT_METHOD.ONLINE,
        title: 'Online',
        icon: 'mdi-web',
    },
];
export function paymentMethodTitle(method) {
    return PAYMENT_METHODS.find(x => x.id === method)?.title ?? method;
}
/** Money state of a lesson, as the detail and the grid tooltip name it. */
export const PAYMENT_STATE_TITLES = {
    paid: 'Zaplaceno',
    unpaid: 'Nezaplaceno',
    refund: 'K vrácení',
    topup: 'K doplacení',
};
export const PAYMENT_STATE_COLORS = {
    paid: 'green',
    unpaid: 'warning',
    refund: 'red',
    topup: 'orange',
};
export const EET_STATUS_TITLES = {
    skipped: 'Neodesláno',
    pending: 'Odesílá se',
    confirmed: 'Potvrzeno',
    failed: 'Chyba',
};
export const EET_STATUS_COLORS = {
    skipped: 'grey',
    pending: 'orange',
    confirmed: 'green',
    failed: 'red',
};
export const EET_STATUSES = [
    { id: 'skipped', title: EET_STATUS_TITLES.skipped },
    { id: 'pending', title: EET_STATUS_TITLES.pending },
    { id: 'confirmed', title: EET_STATUS_TITLES.confirmed },
    { id: 'failed', title: EET_STATUS_TITLES.failed },
];
